import type { Size, SizeSpec } from '@geom';
import type { Image, ImageOrigin, ImageSource } from '@image';

/**
 * Lightweight placeholder ImageSource used by CadetReader for :IMAGE directives.
 * Carries origin metadata and defers any actual I/O or rendering.
 */
export class UnresolvedImageSource implements ImageSource {
  readonly id: string;
  readonly origin?: ImageOrigin;
  readonly scalable: boolean;
  readonly isLoaded = false;

  constructor(id: string, origin: ImageOrigin) {
    this.id = id;
    this.origin = origin;
    this.scalable = origin.type === 'svg';
  }

  async load(): Promise<void> {
    /* no-op */
  }

  get intrinsicSize(): Size {
    throw new Error('UnresolvedImageSource has no intrinsic size; load/resolve first.');
  }

  render(_sizeSpec?: SizeSpec): Image {
    throw new Error(
      'UnresolvedImageSource cannot render; resolve to a concrete image first.'
    );
  }

  toString(): string {
    return `UnresolvedImageSource(${this.id})`;
  }
}
